import axios from '@/core/http'

const fetchPlugins = () => {
  return axios.get('spiders/plugins/').then(res => res.data['results'])
}

export { fetchPlugins }
